module.exports = __webpack_public_path__ + "img/WL-graphics.c0de54d3.png";